// extracted by mini-css-extract-plugin
module.exports = {"container":"MainTemplate_container__7DrAv"};